<script>

    export let w = 400;
    export let h = 600;
    export let strokeOnly = false;


    export let circlesCount = 80;

    function randomNumber(n){
        return Math.floor(Math.random()*n);
    }


</script>

<svg viewbox="0 0 {w} {h}"  >

    {#if strokeOnly}
    

    {#each Array(circlesCount) as _, i}
        <!-- <circle r="{randomNumber(w)}" cx="{randomNumber(w)}" cy="{randomNumber(h)}"  fill="{i % 2 ? 'rgba(255,255,255,.2)': 'rgba(0,0,0,.2)'}" /> -->
        <circle r="{randomNumber(200)}" cx="{randomNumber(600)+-200}" cy="{randomNumber(900)+-300}"  fill="rgba(0,0,0,{Math.random()-.5})" />
    {/each}

    {:else}

    <rect width="{w}" height="{h}" x="0" y="0" fill="#000"/>
    

    {#each Array(circlesCount*4) as _, i}
        <!-- <circle r="{randomNumber(w)}" cx="{randomNumber(w)}" cy="{randomNumber(h)}"  fill="{i % 2 ? 'rgba(255,255,255,.2)': 'rgba(0,0,0,.2)'}" /> -->
        <circle r="{randomNumber(200)}" cx="{randomNumber(600)+-200}" cy="{randomNumber(900)+-300}" fill="none"  stroke="#fff" stroke-width="3"  stroke-opacity={Math.random()-.3}/>
    {/each}

    {/if}

    

</svg>